import {Controller} from "stimulus"
import $ from 'jquery';

import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es";
import {english} from "flatpickr/dist/l10n/default";
import {set_locale} from './localize_controller'
import {Russian} from "flatpickr/dist/l10n/ru";
import {French} from "flatpickr/dist/l10n/fr";
import {Italian} from "flatpickr/dist/l10n/it";
import {German} from "flatpickr/dist/l10n/de";
import {Portuguese} from "flatpickr/dist/l10n/pt";
import {MandarinTraditional} from "flatpickr/dist/l10n/zh-tw";
import {disable_dates} from "./preferences_controller";
// require("flatpickr/dist/themes/airbnb.css")

export let flatpick_lang;

export default class extends Controller {

    connect() {
        set_locale().then(
            locale => {
                // ✅ FIX: Bootstrap modal + Flatpickr focus loop
                $(document).on('focusin', function(e) {
                    if ($(e.target).closest('.flatpickr-calendar').length) {
                        e.stopImmediatePropagation();
                    }
                });

                switch (I18n.locale) {
                    case 'es':
                        flatpick_lang = Spanish;
                        break;
                    case 'en':
                        flatpick_lang = english;
                        break;
                }

                flatpickr(".datepicker", {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    minDate: "today",
                    locale: flatpick_lang,
                    disableMobile: "true"
                })

                flatpickr(".timepicker", {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "h:i",
                    time_24hr: false,
                    locale: flatpick_lang,
                    disableMobile: "true"
                })

                flatpickr(".timepicker-24", {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    time_24hr: true,
                    minuteIncrement: false,
                    locale: flatpick_lang,
                    disableMobile: "true"
                })

                flatpickr("#date_range", {
                    mode: "range",
                    dateFormat: "Y-m-d",
                    locale: flatpick_lang,
                    minDate: "today",
                    showMonths: 1,
                    onReady: function(selectedDates, dateString, instance) {
                        // Establecer placeholder inicial si no hay valor
                        if (instance.input.value !== undefined && !instance.input.value.trim()) {
                            instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                        }
                    },
                    onValueUpdate: function(selectedDates, dateString, instance) {
                        // Si el campo queda vacío (ej. usuario borra), restaurar placeholder
                        if (!dateString) {
                            instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                        } else {
                            instance.input.removeAttribute("placeholder");
                        }
                    }
                });
                flatpickr("#hotetec_date_range", {
                    mode: "range",
                    dateFormat: "Y-m-d",
                    locale: flatpick_lang,
                    minDate: "today",
                    showMonths: 1,
                    onReady: function(selectedDates, dateString, instance) {
                        // Establecer placeholder inicial si no hay valor
                        if (instance.input.value !== undefined && !instance.input.value.trim()) {
                            instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                        }
                    },
                    onValueUpdate: function(selectedDates, dateString, instance) {
                        // Si el campo queda vacío (ej. usuario borra), restaurar placeholder
                        if (!dateString) {
                            instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                        } else {
                            instance.input.removeAttribute("placeholder");
                        }
                    }
                });
                flatpickr("#home_date_range_details", {
                    mode: "range",
                    dateFormat: "Y-m-d",
                    locale: flatpick_lang,
                    minDate: "today",
                    showMonths: 1,
                    onReady: function(selectedDates, dateString, instance) {
                        // Establecer placeholder inicial si no hay valor
                        if (instance.input.value !== undefined && !instance.input.value.trim()) {
                            instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                        }
                    },
                    onValueUpdate: function(selectedDates, dateString, instance) {
                        // Si el campo queda vacío (ej. usuario borra), restaurar placeholder
                        if (!dateString) {
                            instance.input.setAttribute("placeholder", I18n.t('home.page.select_range_date'));
                        } else {
                            instance.input.removeAttribute("placeholder");
                        }
                    }
                });
            }
        )
    }
}